"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("../../themes/main/colors");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var edit = _a.edit;
            return ({
                backgroundColor: edit ? colors_1.materialColors.yellow[50] : undefined,
            });
        },
        cell: {
            padding: '14px 12px',
            fontSize: '13px',
            '&:first-child': {
                paddingLeft: '20px',
            },
        },
        row: {
            borderStyle: 'none',
            '&:last-child .MuiTableCell-root': {
                borderBottomStyle: 'none',
            },
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#fffbef',
            },
        },
    });
});
